module.exports = __webpack_public_path__ + "img/Home BESS 1.edd625b8.svg";